import React from "react";
import PropTypes from "prop-types";
import LookListFeatureCheckmark from "../lookNavigation/lookMain/lookListFeature/lookListFeatureCheckmark";
import FeatureThumbnail from "../../visComponents/featureThumbnail";
import FeatureName from "../../visComponents/featureName";
import LookFeaturePrice from "../lookNavigation/lookMain/lookListFeature/lookFeaturePrice";
import {featureInterface} from "../../../interfaces/featureInterface";

const LookStylePopupFeature = (props) => {

  const {lookFeature} = props;

  return (
    <li className="lm-feature lm-feature--simple">
      <div className="lm-feature__thumbnail">
        <LookListFeatureCheckmark lookFeature={lookFeature}/>
        <FeatureThumbnail feature={lookFeature}/>
      </div>
      <div className="lm-feature__content">
        <span className="lm-feature__content-name">
          <FeatureName feature={lookFeature} useCollectionName={true}/>
        </span>
        <p className="lm-feature__content-description">
          <FeatureName feature={lookFeature}/>
        </p>
        <div className="lm-feature__price">
          <LookFeaturePrice lookFeature={lookFeature} />
        </div>
      </div>
    </li>
  )
};

LookStylePopupFeature.propTypes = {
  lookFeature: PropTypes.shape(featureInterface).isRequired,
}


export default LookStylePopupFeature
